import { IUserLog, getRequestData, formatUserData } from './index';
import client from './client';

export default (cid: string, user: IUserLog): void => {
    client.info('context loaded', {
        cid,
        context: 'hooks/useGetContext',
        ...formatUserData(user),
        ...getRequestData(),
    });
};
